import Helper from 'src/support/Helper';
import _, { isNumber, isObject } from 'underscore';

class ResponseMaker {
    data = [];
    data_to_send = {
        orderItemList: {}
    };

    constructor(data) {
        this.data = data;
    }

    process = async () => {
        if (this.data.shipments !== undefined && this.data.shipments.length > 0) {
            let value = [];

            let currencyVal = ''
            if (this.data.currency) {
                currencyVal = this.data.currency && this.data.currency
            }

            this.data.shipments.map((v, i) => {
                let here_v = {}
                if (v['shipDate']) {
                    here_v.shippedDate = v['shipDate']
                    here_v.finalShippedDate = Helper.dateFormatFromString(v['shipDate'])
                }
                if (v['shipTrackingNumber']) {
                    here_v.trackingNumber = v['shipTrackingNumber']
                }
                if (v['shipInvoiceNumber']) {
                    here_v.invoiceNumber = v['shipInvoiceNumber']
                }
                if (v['shipReleaseNumber']) {
                    here_v.releaseNumber = v['shipReleaseNumber']
                }
                if (v['shipNumber']) {
                    here_v.shipNumber = v['shipNumber']
                }
                if (v['items'] && v['items'].length > 0) {
                    let finalItems = []
                    v['items'].map((j, i) => {
                        let here_j = {}
                        if (j.lineItemNumber) {
                            here_j.lineItemNumber = j.lineItemNumber
                        }
                        if (j.manufacturer) {
                            here_j.manufacturer = j.manufacturer
                        }
                        if (j.manufacturerName) {
                            here_j.manufacturerName = j.manufacturerName
                        }
                        if (j.manufacturerPartNumber) {
                            here_j.manufacturerPartNumber = j.manufacturerPartNumber
                        }
                        if (j.customerPartNumber) {
                            here_j.customerPartNumber = j.customerPartNumber
                        }
                        if (j.qtyOrdered) {
                            here_j.orderedQuantity = j.qtyOrdered
                        } else {
                            here_j.orderedQuantity = 0
                        }
                        if (j.qtyDelivered) {
                            here_j.deliveredQuantity = j.qtyDelivered
                        } else {
                            here_j.deliveredQuantity = 0
                        }
                        if (j.qtyRemaining) {
                            here_j.remainingQuantity = j.qtyRemaining
                        } else {
                            here_j.remainingQuantity = 0
                        }
                        if (j.priceLineTotal) {
                            here_j.totalPrice = j.priceLineTotal
                        } else {
                            here_j.totalPrice = 0
                        }
                        if (j.pricePerUnit) {
                            here_j.unitPrice = j.pricePerUnit
                        } else {
                            here_j.unitPrice = 0
                        }
                        if (j.orderType) {
                            here_j.orderType = j.orderType
                        }
                        if (j.invoiceNum) {
                            here_j.invoiceNumber = j.invoiceNum
                        }
                        if (j.carrier) {
                            here_j.carrier = j.carrier
                        }
                        if (j.status) {
                            here_j.orderStatus = j.status.toLowerCase() === 'pending' ? 'Order Placed' : j.status
                        }
                        if (j.itemOrderDate) {
                            here_j.orderDate = j.itemOrderDate
                            here_j.finalOrderDate = Helper.dateFormatFromString(j['itemOrderDate'])
                        }
                        if (j.deliveryDate) {
                            here_j.deliveryDate = j.deliveryDate
                            here_j.finalDeliveryDate = Helper.dateFormatFromString(j['deliveryDate'])
                        }

                        here_j.ERPPartNumber = j.matnr

                        here_j.currency = currencyVal
                        here_j.uniqueNumber = Helper.UUID()

                        finalItems.push(here_j)
                    })
                    here_v.items = finalItems
                }
                value[i] = here_v;
            })

            this.data_to_send.orderItemList = value
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;